import isEmpty from "../../validation/is-empty";

export function filterData(tableData, filters, filterColumns) {
  if (isEmpty(tableData)) {
    return [];
  }

  if (isEmpty(filters)) {
    return tableData;
  }

  return tableData.filter((row) =>
    applyFiltersToRow(row, filters, filterColumns)
  );
}

function applyFiltersToRow(row, filters, filterColumns) {
  let valcheck = true;
  const textColumns = {};

  // Process all filters
  for (let filter of filters) {
    if (!valcheck) break;

    const columnInfo = getColumnInfo(filter.column, filterColumns);
    valcheck = processFilter(row, filter, columnInfo, textColumns, valcheck);
  }

  // Final validation for text columns
  if (valcheck) {
    valcheck = validateTextColumns(textColumns);
  }

  return valcheck;
}

function getColumnInfo(columnKey, filterColumns) {
  return filterColumns.filter((x) => x.key === columnKey);
}

function processFilter(row, filter, columnInfo, textColumns, valcheck) {
  const filterValue = filter.text;
  const rowValue = row[filter.column];

  if (isNumerical(columnInfo)) {
    return numericalCheck(valcheck, filter, rowValue, filterValue);
  } else {
    return processTextFilter(filter, rowValue, filterValue, textColumns);
  }
}

function processTextFilter(filter, rowValue, filterValue, textColumns) {
  const columnKey = filter.column;

  // Initialize column tracking if needed
  if (!textColumns[columnKey]) {
    textColumns[columnKey] = { passes: false, hasAll: false };
  }

  // Check if this is an "All" selection
  if (filterValue === "__ALL__") {
    textColumns[columnKey].hasAll = true;
  } else if (textCheck(rowValue, filterValue, filter.isPartialMatch)) {
    textColumns[columnKey].passes = true;
  }

  return true; // Continue processing other filters
}

function validateTextColumns(textColumns) {
  for (let column in textColumns) {
    // If "All" is selected for this column, it always passes
    if (!textColumns[column].hasAll && !textColumns[column].passes) {
      return false;
    }
  }
  return true;
}

function isNumerical(c) {
  return (
    c[0].type.includes("CURRENCY") ||
    c[0].type.includes("PERCENT") ||
    c[0].type.includes("QUANTITY")
  );
}

function validateFilterMinNumber(value) {
  return value ? parseInt(value) : 0;
}
function validateFilterMaxNumber(value) {
  return value ? parseInt(value) : Infinity;
}

function textCheck(rowValue, filterValue, isPartialMatch = false) {
  // Handle null/undefined values
  if (rowValue == null && filterValue == null) return true;
  if (rowValue == null || filterValue == null) return false;

  // Convert to string for comparison
  const rowStr = String(rowValue).toLowerCase();
  const filterStr = String(filterValue).toLowerCase();

  // Use partial matching for description filters, exact matching for multi-select
  if (isPartialMatch) {
    return rowStr.indexOf(filterStr) !== -1;
  } else {
    return rowStr === filterStr;
  }
}
function numericalCheck(valcheck, filter, rowValue, filterValue) {
  if (filter.minOrMax === "min") {
    return valcheck && rowValue * 1 >= validateFilterMinNumber(filterValue);
  } else {
    return valcheck && rowValue * 1 <= validateFilterMaxNumber(filterValue);
  }
}
